<template>
  <!-- 评价中心页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar
        left-text="进度详情"
        left-arrow
        @click-left="$router.back()"
      />
    </div>
    <div class="center">
      <div class="logisticsInfo">
        <van-steps direction="vertical" :active="0">
          <van-step v-for="(item, index) in logisticsList" :key="index">
            <span>{{ item.service_desc }}</span>
            <p>{{ item.add_time }}</p>
          </van-step>
        </van-steps>
      </div>
    </div>
    <van-loading
      color="#1989fa"
      size="1rem"
      vertical
      v-show="LoadingShow"
      type="spinner"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      logisticsList: {},
      LoadingShow: false,
      logName: "",
      logPhone: "",
      logisticsNum: "",
    };
  },
  created() {
    this.getSaleService();
  },
  methods: {
    // 获取物流信息
    async getSaleService() {
      this.LoadingShow = true;
      let saleCode = this.$route.query.service_code;
      await this.$post({
        url: "/saleService/findTurnoverBySaleId",
        method: "get",
        params: {
          saleCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.LoadingShow = false;
            this.logisticsList = res.data;
          }
        })
        .catch((err) => {
          this.LoadingShow = false;
          this.$toast("加载失败");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
  background: rgba(245, 245, 245, 1);
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #fff;
    .van-nav-bar {
      background-color: #40000000;
      /deep/.van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #030303;
         font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 500 !important;
      }
    }
  }
  .center {
    background-color: #ffffff;
    padding-top: 1.2rem;
    .logisticsTitle {
      margin-top: 1rem;
      img {
        margin-left: 2rem;
        width: 1.8rem;
        height: 1.8rem;
        display: inline-block;
        vertical-align: middle;
      }
      .logisticsName {
        margin-left: 0.3rem;
        font-size: 0.42rem;
        display: inline-block;
        vertical-align: middle;
      }
      .logisticsNumInfo {
        text-align: center;
        .logisticsNum {
          display: inline-block;
          text-align: center;
          margin-top: 0.5rem;
          font-size: 0.42rem;
        }
        .button {
          margin-left: 0.5rem;
          font-size: 0.32rem;
          width: 1.2rem;
          height: 0.6rem;
        }
      }
    }
    .dividingLine {
      margin-top: 0.5rem;
      width: 100%;
      height: 0.2rem;
      background-color: #ffffff;
    }
    .logisticsInfo {
      margin: 0 0.27rem;
      height: 100%;
      .van-steps {
        background-color: #ffffff !important;
      }
    }
  }
  .van-loading {
    z-index: 99;
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
